import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'
console.log('env')
console.log(env)
console.log(process.env.NODE_ENV)


export const APP_NAME = 'Lavender Logistics';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const BASE_URL = env.BASE_URL;
export const DOMAIN_URL = env.DOMAIN_URL;
export const ADMIN_API_BASE_ENDPOINT = API_BASE_URL + '';
export const PUBLIC_API_BASE_ENDPOINT = API_BASE_URL + 'api/';
// export const DEMO_SERVER_ENDPOINT = 'http://demo_server.cloudlogisitc.com/api/sub_admin/';
export const DEMO_SERVER_ENDPOINT = API_BASE_URL + 'subAdminProxy/';
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const PER_PAGE_DATA = 100;
export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const ONLY_DATE_FORMAT = 'YYYY-MM-DD';
export const YEAR_FORMAT = 'YYYY';
export const MONTH_FORMAT = 'MMMM';
export const ONLY_TIME_FORMAT = 'HH:mm';
export const TIME_FORMAT = 'HH:mm:ss';
export const GOOGLE_MAP_KEY = 'AIzaSyDnOQS1VsTVqknhTyvaWgk-U0BOE2KahhI';
// export const AWS_S3_URL = 'https://dui7sst88kk80.cloudfront.net/';
export const AWS_S3_URL = 'https://dfulmqtugkhua.cloudfront.net/';
export const SOCKET_URL = env.SOCKET_URL;
export const UPLOAD_FILE_MAX_SIZE = 10;

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR
};
